// app/javascript/controllers/form_validation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "enabledButton", "disabledButton", "counter"]
  static values = { limit: Number }

  connect() {
    this.check();
  }

  check() {
    const length = this.inputTarget.value.trim().length;
    const isNotEmpty = length > 0;

    this.updateCounter(length);
    this.toggleButtons(isNotEmpty);
  }

  updateCounter(length) {
    if (!this.hasCounterTarget) return;

    this.counterTarget.textContent = `${length} / ${this.limitValue}`;

    const isNearLimit = length >= (this.limitValue * 0.95);
    this.counterTarget.classList.toggle("hidden", !isNearLimit);
  }

  reset() {
    this.toggleButtons(false);
    if (this.hasCounterTarget) this.counterTarget.textContent = `0 / ${this.limitValue}`;
  }

  toggleButtons(active) {
    this.enabledButtonTarget.classList.toggle("hidden", !active);
    this.disabledButtonTarget.classList.toggle("hidden", active);
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.inputTarget.form.requestSubmit();
    }
  }
}
